import { type ComponentPropsWithoutRef } from "react";

import { Button } from "@src/shared/components/ui/button";
import { cn } from "@src/shared/lib/utils";
import { getAssetUrl } from "@src/shared/utils/assets/getAssetUrl";

import { useLoginWithElationFlow } from "../../../application/v2";

type ButtonProps = Omit<
  ComponentPropsWithoutRef<typeof Button>,
  "onClick" | "disabled"
> & {
  enabled?: boolean;
};

export function LoginWithElationButton({
  className,
  enabled,
  ...props
}: ButtonProps) {
  const elation = useLoginWithElationFlow();
  const isEnabled = enabled ?? elation.enabled;

  if (!isEnabled) return null;

  return (
    <Button
      {...props}
      className={cn(
        "bg-[#1C94BC] text-white hover:bg-[#177fa3] active:bg-[#146d8d]",
        className,
      )}
      disabled={elation.isSubmitting}
      onClick={elation.login}
    >
      <img
        alt=""
        aria-hidden="true"
        className="size-5 rounded-full"
        src={getAssetUrl("/images/elation-compact-logo.svg")}
      />
      {props.children ?? "Sign in with Elation"}
    </Button>
  );
}
